// extracted by mini-css-extract-plugin
export default {"boardsContainer":"BoardsPage_boardsContainer__is6GU","title":"BoardsPage_title__tIGEV"};